<template>
  <div class="outfit-selector">
    <label>Clothing</label>
    <md-field class="clothing-field">
      <md-select
        class="clothing-select"
        placeholder="Select Clothing"
        aria-label="Select Clothing"
        data-testid="select-clothing-button"
        :value="outfitValue"
        :disabled="readonly"
        @input="updateOutfit"
      >
        <md-option v-for="item of availableOutfits" :key="item.key" :value="item.key" :aria-label="`${item.label} outfit`" data-testid="outfit-option">
          {{ item.label }}
        </md-option>
      </md-select>
    </md-field>
    <div v-if="showOnAtStart">
      <label class="on-at-start-label">Clothing at Start</label>
      <md-field>
        <md-select
          class="on-at-start-select"
          placeholder="Clothing at Start"
          aria-label="Clothing at Start"
          data-testid="clothing-at-start-button"
          :value="outfit.onAtStart"
          :disabled="readonly"
          @input="updateOnAtStart"
        >
          <md-option v-for="item of onAtStartOptions" :key="item.key" :value="item.key" :aria-label="`${item.label.en} at start`" data-testid="clothing-on-at-start-option">
            {{ item.label.en }}
          </md-option>
        </md-select>
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  name: 'outfit-selector',
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    avatar: {
      type: Object,
      default: () => {}
    },
    outfit: {
      type: Object,
      default: () => {}
    },
    showOnAtStart: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      onAtStartOptions: [
        { key: 'CLOTHES_ON', label: { en: 'Clothed' }},
        { key: 'UNDERWEAR_ON', label: { en: 'Underwear' }},
        { key: 'UNDERWEAR_OFF', label: { en: 'Nude' }}
      ]
    };
  },
  computed: {
    outfitValue() {
      let value;
      if (this.outfit) {
        value = `${this.outfit.clothingType}${this.outfit.isDirty ? '_DIRTY' : '' }`;
      }
      return value;
    },
    availableOutfits() {
      const outfits = [];
      const { genderType, defaultOutfit, defaultIslamicOutfit } = this.avatar.avatarOptions;
      if (this.user.productType === 'MILITARY') {
        outfits.push({ key: 'MILITARY_OUTFIT_1', label: 'Military Fatigues' });
        outfits.push({ key: defaultOutfit, label: 'Civilian Clothing' });
        outfits.push({ key: defaultOutfit + '_DIRTY', label: 'Civilian Clothing (Dirty)' });
        if (defaultIslamicOutfit) {
          outfits.push({ key: defaultIslamicOutfit, label: 'Civilian Clothing + Hijab' });
        }
      }
      else {
        outfits.push({ key: defaultOutfit, label: 'Default Clothing' });
        outfits.push({ key: defaultOutfit + '_DIRTY', label: 'Default Clothing (Dirty)' });
        if (defaultIslamicOutfit) {
          outfits.push({ key: defaultIslamicOutfit, label: 'Default Clothing + Hijab' });
        }
      }
      if (genderType === 'FEMALE') {
        outfits.push({ key: 'OUTFIT_ISLAMIC_1', label: 'Niqab' });
      }
      outfits.push({ key: 'OUTFIT_GOWN_1', label: 'Gown' });
      outfits.push({ key: 'POLICE_OUTFIT_1', label: 'Police Uniform' });
      return outfits;
    }
  },
  methods: {
    updateOutfit(value) {
      if (!value) {
        return;
      }
      let clothingType;
      let isDirty;
      if (value.endsWith('_DIRTY')) {
        clothingType = value.slice(0, value.indexOf('_DIRTY'));
        isDirty = true;
      } else {
        clothingType = value;
        isDirty = false;
      }
      this.$emit('update', { clothingType, isDirty, onAtStart: this.outfit.onAtStart });
    },
    updateOnAtStart(value) {
      if (!value) {
        return;
      }
      this.$emit('update', {
        clothingType: this.outfit.clothingType,
        isDirty: this.outfit.isDirty,
        onAtStart: value
      });
    }
  }
}
</script>

<style scoped>
.clothing-field {
  margin-bottom: 10px;
}
</style>